import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { AuthContext } from 'app/shared/context/Auth';
import { PermissionsContext } from 'app/shared/context/Permissions';
import ExternalRedirect from 'app/shared/components/atoms/ExternalRedirect';

const userHasCommercialCuratorOrganizerGroup = (permissions?: any[]) =>
  permissions &&
  permissions
    .filter((p: any) => p.resourceType === 'OrganizerGroup')
    .some(
      (p: any) =>
        p.resourceExtraData &&
        p.resourceExtraData.organizerGroupType == 'curator_commercial'
    );

const withUserAgreements = (
  PassedComponent: React.ComponentType<React.PropsWithChildren<any>>,
  permissionName?: string
) => {
  return (props: any) => {
    const { user } = useContext(AuthContext);
    const location = useLocation();
    const { permissions, permissionsLoaded, hasPermission } =
      useContext(PermissionsContext);
    if (!permissionsLoaded) {
      return <PassedComponent {...props} />;
    }

    if (permissionName && !hasPermission(permissionName)) {
      return <PassedComponent {...props} />;
    }

    if (
      (!hasPermission('user.acknowledgeCuratorAgreement3') ||
        !userHasCommercialCuratorOrganizerGroup(permissions)) &&
      user &&
      !user.acknowledgedGdprAgreementAt
    ) {
      return (
        <ExternalRedirect
          to={`/admin/confidentiality-agreement?referrer_path=${location.pathname}`}
        />
      );
    }

    if (
      hasPermission('user.acknowledgeCuratorAgreement3') &&
      userHasCommercialCuratorOrganizerGroup(permissions) &&
      user &&
      !user.acknowledgedCuratorAgreement3At
    ) {
      return (
        <ExternalRedirect
          to={`/admin/curator-agreement-3?referrer_path=${location.pathname}`}
        />
      );
    }

    return <PassedComponent {...props} />;
  };
};

export default withUserAgreements;
